import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse
} from '@material-ui/core';

import DownIcon from '@material-ui/icons/KeyboardArrowDown';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';

import { useSelector } from 'react-redux';

import { getDishCheckInSummary } from '../../../../store/ticket';

const DishSummary = props => {
  // const {couponsCount } = props;
  const summaryData = useSelector(getDishCheckInSummary);
  const [summary, setSummary] = useState({});
  const [summaryCount, setSummaryCount] = useState({});

  useEffect(() => {
    if (summaryData) {
      setSummary(summaryData);
      const countData = Object.keys(summaryData).reduce(
        (res, key) => {
          res['checked'] += summaryData[key]['checked'];
          res['total'] += summaryData[key]['total'];
          res['remain'] += summaryData[key]['remain'];
          return res;
        },
        { total: 0, remain: 0, checked: 0 }
      );
      setSummaryCount(countData);
    }
  }, [summaryData]);

  const [collapse, setCollapse] = useState(false);

  const handleCollapse = async () => {
    setCollapse(!collapse);
  };

  const countDishes = summary => {};

  return (
    <Card>
      {summary && Object.keys(summary).length > 0 && (
        <Fragment>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <IconButton
                    aria-label="minus"
                    onClick={handleCollapse}
                    size="small">
                    {!collapse && <DownIcon />}
                    {collapse && <UpIcon />}
                  </IconButton>
                </TableCell>
                <TableCell>
                  Всего {!collapse ? summaryCount['total'] : ''}
                </TableCell>
                <TableCell>
                  Выдано {!collapse ? summaryCount['checked'] : ''}
                </TableCell>
                <TableCell>
                  Осталось {!collapse ? summaryCount['remain'] : ''}
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>

          <Collapse in={collapse}>
            <Table size="small">
              <TableBody>
                {Object.keys(summary).map(key => (
                  <TableRow key={key}>
                    <TableCell>{key}</TableCell>
                    <TableCell>
                      <Typography variant="h5">
                        {summary[key]['total']}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="h5">
                        {summary[key]['checked']}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="h5">
                        {summary[key]['remain']}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Collapse>
        </Fragment>
      )}
    </Card>
  );
};

export default DishSummary;
